<script setup lang="ts">
/**
 * /privacy: the Privacy Policy from content/legal/privacy.md. One document,
 * not versioned (information, not a contract).
 */
const { public: { siteUrl } } = useRuntimeConfig()

const title = 'Privacy Policy | Clarify'
const description = 'How Clarify, the ticket bot for Discord, processes personal data and which rights you have.'
const canonical = `${siteUrl}/privacy`

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogUrl: canonical,
  robots: 'index, follow'
})
useHead({ link: [{ rel: 'canonical', href: canonical }] })

const { data: html } = await useAsyncData('legal-privacy', () => loadPrivacyPolicy())
</script>

<template>
  <LegalDocument
    eyebrow="Datenschutzerklärung"
    title="Privacy Policy"
    lead="How Clarify processes personal data and which rights you have."
    :html="html ?? ''"
  />
</template>
